import {
  normalizeDateFromApi,
  normalizeDateForApi,
} from 'helpers/datetimeHelpers';
import { ProductParams } from './products.types';

export function normalizeApiResponse(data: ProductParams): ProductParams {
  if (!data.timedSegments) {
    return { ...data };
  }

  const segments = data.timedSegments.map(segment => ({
    ...segment,
    startDate: normalizeDateFromApi(segment.startDate),
    endDate: segment.endDate ? normalizeDateFromApi(segment.endDate) : null,
  }));
  return { ...data, timedSegments: segments };
}

export function normalizeApiRequest(data: ProductParams): ProductParams {
  const result: ProductParams = { ...data };

  if (result.generalValue) {
    const gv = { ...result.generalValue };

    if (gv.visualSpec?.files) {
      gv.visualSpec = {
        ...gv.visualSpec,
        files: gv.visualSpec.files
          .filter(f => f && Object.keys(f).length > 0)
          .map((f: any) => ({ id: f.id })),
      };
    }

    if (gv.technicalSpec?.files) {
      gv.technicalSpec = {
        ...gv.technicalSpec,
        files: gv.technicalSpec.files
          .filter(f => f && Object.keys(f).length > 0)
          .map((f: any) => ({ id: f.id })),
      };
    }

    result.generalValue = gv;
  }

  if (!result.timedSegments) {
    return result;
  }

  const segments = result.timedSegments.map(segment => ({
    ...segment,
    startDate: normalizeDateForApi(segment.startDate),
    endDate: segment.endDate ? normalizeDateForApi(segment.endDate) : null,
  }));
  return { ...result, timedSegments: segments };
}

export function prepareTimedSegmentsPayloadForApi(
  data: ProductParams,
): ProductParams {
  /**
   * if there is no timedSegmentsIndefinite field, return data as one source of data is timedSegments
   * for cloning for example there is no timedSegmentsIndefinite field because it is not
   * neither create or update action, so indefinite logic is not applied
   */
  if (!data.timedSegmentsIndefinite) {
    return data;
  }
  const type = data.durationType;

  const payload = {
    ...data,
    timedSegments:
      type === 'indefinite'
        ? data.timedSegmentsIndefinite || []
        : data.timedSegments || [],
  };

  delete payload.timedSegmentsIndefinite;

  return payload;
}
